import React, { useEffect, useState } from "react";

export default function UserSetting(props) {
    const [selectedRadio, setSelectedRadio] = useState("US"); // 'us' or 'dk'

    // For US data
    const [USRowData, setUSRowData] = useState(() => {
        const saved = localStorage.getItem("UserSettingUS");
        let savedIDs = [];
        if (saved) {
            try {
                savedIDs = JSON.parse(saved);
            } catch (err) {
                savedIDs = [];
            }
        }
        const initialData = [
            { accordian: "Notes", isOpen: false, id: 0 },
            { accordian: "Forecast & Shipments", isOpen: false, id: 1 },
            { accordian: "Stock Overview", isOpen: false, id: 2 },
            { accordian: "POS Demand", isOpen: false, id: 3 },
            { accordian: "Reprint Inputs", isOpen: false, id: 4 },
            { accordian: "Components on Hand", isOpen: false, id: 5 },
            { accordian: "Production Specs", isOpen: false, id: 6 },
            { accordian: "Title Family & Packs", isOpen: false, id: 7 },
            { accordian: "Marketing & Publicity", isOpen: false, id: 8 },
        ];
        return initialData.map((row) => ({
            ...row,
            isOpen: savedIDs.includes(row.id),
        }));
    });

    // For DK data
    const [DKRowData, setDKRowData] = useState(() => {
        const saved = localStorage.getItem("UserSettingDK");
        let savedIDs = [];
        if (saved) {
            try {
                savedIDs = JSON.parse(saved);
            } catch (err) {
                savedIDs = [];
            }
        }
        const initialData = [
            { accordian: "Notes", isOpen: false, id: 0 },
            { accordian: "Forecast & Reprint", isOpen: false, id: 1 },
            { accordian: "Demand DK", isOpen: false, id: 2 },
            { accordian: "Stock Overview", isOpen: false, id: 3 },
            { accordian: "Production DK", isOpen: false, id: 4 },
            { accordian: "Marketing & Publicity", isOpen: false, id: 5 },
        ];
        return initialData.map((row) => ({
            ...row,
            isOpen: savedIDs.includes(row.id),
        }));
    });

    // Toggle checkbox value for US table
    const handleUSToggle = (id) => {
        const updatedData = USRowData.map((row) => {
            if (row.id === id) {
                return { ...row, isOpen: !row.isOpen };
            }
            return row;
        });
        setUSRowData(updatedData);
        titleAlert("", "updateUser", 'response');
    };

    // Toggle checkbox value for DK table
    const handleDKToggle = (id) => {
        const updatedData = DKRowData.map((row) => {
            if (row.id === id) {
                return { ...row, isOpen: !row.isOpen };
            }
            return row;
        });
        setDKRowData(updatedData);
        titleAlert("", "updateUser", 'response');
    };
    const titleAlert = (message, className = 'info', id) => {
        try {

            const statusAlertElement = document.getElementById(id);

            statusAlertElement.textContent = message;
            statusAlertElement.className = className;

        } catch { console.error("Title alert failed"); }
    }
    // Save only the IDs (where isOpen === true) into local storage
    const handleSave = () => {
        try {
            titleAlert("Updating user settings... ", "updateUser", 'response');
        
                const selectedIDsUS = USRowData.filter((row) => row.isOpen).map((row) => row.id);
            localStorage.setItem("UserSettingUS", JSON.stringify(selectedIDsUS));
            props.setUSAccordSetting(selectedIDsUS);

                const selectedIDsDK = DKRowData.filter((row) => row.isOpen).map((row) => row.id);
            localStorage.setItem("UserSettingDK", JSON.stringify(selectedIDsDK));
            props.setDKAccordSetting(selectedIDsDK);
            titleAlert("Settings saved successfully !", "successUser", 'response');
            
        } catch {
            console.error("saving settings failed");
            titleAlert("Saving settings failed", "errorUser", 'response');
        }
    };
    useEffect(() => {
        setSelectedRadio(props?.audience);
    }, [])
    return (
        <div className="popup-overlay userSetting">
            <div className="srch-popup" style={{ overflowY: "hidden", height: "500px", width: "50%", position:"relative" }}>
                {/* Header Section */}
                <div className="popupHeader">
                    <span className="headerText">Save User Setting</span>
                    <button className="popup-close-btn" onClick={props.onClose}>
                    </button>
                </div>

                {/* Body / Content */}
                <div
                    className="search-popup-content"
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <div className="radioGroupTitle">Select Title Type</div>

                    {/* Radio Buttons & Save Button Container */}
                    <div
                        className="radioGroupContainer"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1rem",
                        }}
                    >
                        <div className="radioGroup">
                            <label>
                                <input
                                    type="radio"
                                    value="US"
                                    checked={selectedRadio === "US"}
                                    onChange={() => setSelectedRadio("US")}
                                />
                                US
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value="DK"
                                    checked={selectedRadio === "DK"}
                                    onChange={() => setSelectedRadio("DK")}
                                />
                                DK
                            </label>
                        </div>
                    </div>

                    {/* Conditional Tables */}
                    {selectedRadio === "US" && (
                        <div style={{ overflow: "auto", marginBottom: "auto" }}>
                            <table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#007DAC", color: "white", fontWeight:"600" }}>Dropdown Name</th>
                                        <th style={{ backgroundColor: "#007DAC", color: "white", fontWeight: "600" }}>Keep Open</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {USRowData.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.accordian}</td>
                                            <td style={{ width: "100px" }}>
                                                <input
                                                    type="checkbox"
                                                    style={{ marginLeft: "35px" }}
                                                    checked={row.isOpen}
                                                    onChange={() => handleUSToggle(row.id)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {selectedRadio === "DK" && (
                        <div style={{ overflow: "auto", marginBottom:"auto" }}>
                            <table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#007DAC", color: "white" }}>Dropdown Name</th>
                                        <th style={{ backgroundColor: "#007DAC", color: "white" }}>Keep Open</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DKRowData.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.accordian}</td>
                                            <td style={{width:"100px"} }>
                                                <input
                                                    type="checkbox"
                                                    style={{ marginLeft:"35px"}}
                                                    checked={row.isOpen}
                                                    onChange={() => handleDKToggle(row.id)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div style={{ marginLeft: "auto", marginRight:"auto" }} id="response"></div>
                    <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <button className="ISBNSubmit ml-0" onClick={handleSave }>Save</button>
                        <button className="ISBNSubmit" onClick={props.onClose }>Close</button>
                    </div>
                </div>
         
            </div>
        </div>
    );
}
